import { getLayoutDataOfDetailviewElements } from "../../InitialRenderingData";
import { newProcessLayout } from "../../GridLayoutFunc";
import { convertGridToPixels } from "../../../Pages/FlexibleLayout/utils";

export const getInitialConfigForKanban = (config, options) => {
  const kanbanConfig = JSON.parse(JSON.stringify(config));
  let positionLayoutConfig;

  const layout = getLayoutDataOfDetailviewElements(kanbanConfig.config.data.elements || [], options.tableData);
  const { layout: processedLayout, layoutData, nestedGridData } = layout;
  let { elements } = newProcessLayout(layoutData, nestedGridData, processedLayout);
  kanbanConfig.config.data.elements = elements;
  if (config.device === "mobile") {
    positionLayoutConfig = convertGridToPixels(
      config.position_block_config || [],
      config.position_block_metadata?.grid_size || 4
    );
  }

  return { config: kanbanConfig, options: { layout, positionLayoutConfig } };
};
